import assert from 'assert';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {LegacyAssaySchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {assaySchemaURL, resultSchemaURL, runSchemaURL} from 'results/assay-schemas/AssaySchemaDAO';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {ChipItem, SmartChipType} from 'ui-library/chips/useSmartChipQuery';

function getAssaySchemaUrl(item: ChipItem<SmartChipType.ASSAY_SCHEMA>): string {
  switch (item.__typename) {
    case 'ResultSchemaNode':
      return resultSchemaURL(item.id);
    case 'RequestSchemaNode':
      return assaySchemaURL(LegacyAssaySchemaType.ASSAY_REQUEST, item.id);
    case 'RunSchemaNode':
      return runSchemaURL(item.id);
    default:
      assert(false, `Unexpected assay schema typename: ${item.__typename}`);
  }
}

export default function AssaySchemaChip(
  props: SharedSmartChipProps<SmartChipType.ASSAY_SCHEMA>
): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: schema,
    handleClickLink,
    isInaccessible,
    itemUrl: schemaUrl,
  } = useSmartChipQuery<SmartChipType.ASSAY_SCHEMA>({
    id,
    onClick,
    getUrlFn: getAssaySchemaUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={ModelTypeConstants.ASSAY_SCHEMA}
      isInaccessible={isInaccessible}
      item={schema}
      onClick={handleClickLink}
      url={schemaUrl}
    />
  );
}
